import * as React from 'react';
import { WComponent, WComponentProps, WComponentState } from '../WComponent';
import style from './buttons.less';
import * as classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

interface WActionButtonProps extends WComponentProps {
    tooltip?: string;
    label: string;
    action: string;
    disabled?: boolean;
    style?: string;
    styleProps?: React.CSSProperties;
    divStyle?: React.CSSProperties;
    indicatorValue?: number;
    indicatorChar?: string;
    indicatorColor?: string;
    indicatorFullNumber?: boolean;
    sidetext?: string;
    insideText?: string | JSX.Element;
    insideLeftMargin?: number;
    place?: string;
    onAction(action: string, event?: any): void;
}

// export class WActionButton extends React.Component<WActionButtonProps, {}> {
export class WActionButton extends WComponent<WActionButtonProps, {}> {
    constructor(props: any) {
        super(props);
        this.tooltip_id = 'tooltip_' + Date.now() + '_' + Math.floor(Math.random() * 10000);
    }

    private tooltip_id: string = null;

    render() {
        let indicator: JSX.Element = undefined;
        if (this.props.indicatorValue || this.props.indicatorColor) {
            let indiValue: any = undefined;
            let cls;
            if (this.props.indicatorChar) {
                indiValue = this.props.indicatorChar;
                cls = style.indicator;
            } else {
                if (this.props.indicatorValue > 9 && !this.props.indicatorFullNumber) {
                    indiValue = '9+';
                } else {
                    indiValue = this.props.indicatorValue;
                }
                if (this.props.indicatorValue > 9) {
                    cls = style.indicator_dyn;
                } else {
                    cls = style.indicator;
                }
            }
            const indiColor = this.props.indicatorColor ? this.props.indicatorColor : '#CCC';
            indicator = <div className={cls} style={{ backgroundColor: indiColor }}> {indiValue} </div>;
        }

        let caseStyle = 'small';
        switch (this.props.style) {
            case 'small': {
                caseStyle = style.actionButtonSmall;
                break;
            }
            case 'medium': {
                caseStyle = style.actionButtonMedium;
                break;
            }
            case 'big': {
                caseStyle = style.actionButtonBig;
                break;
            }
            case 'theme_small': {
                caseStyle = style.actionButtonThemeSmall;
                break;
            }
            case 'theme': {
                caseStyle = style.actionButtonTheme;
                break;
            }
            case 'theme_tab1': {
                caseStyle = style.actionButtonThemeTab1;
                break;
            }
            default: {
                caseStyle = style.actionButton;
                break;
            }
        }

        const btnStyle: React.CSSProperties = { ...(this.props.styleProps || {}) };
        if (typeof this.props.insideText === 'string' && this.props.insideText.length > 0) {
            btnStyle.backgroundPosition = 'left';
            btnStyle.backgroundPositionX = '5px';
            if (!btnStyle.hasOwnProperty('width')) {
                btnStyle.width = 'auto';
            }
        }
        const insideMargin = (this.props.insideLeftMargin || this.props.insideLeftMargin === 0) ?
            this.props.insideLeftMargin
            : this.props.style === 'theme_small' ? 15 : 25;
        return (
            <div style={this.props.divStyle}>
                {indicator}
                <button
                    className={classNames(caseStyle, style[this.props.action])}
                    onClick={() => { }}
                    disabled={this.props.disabled}
                    onMouseUp={(event: any) => { this.props.onAction(this.props.action, event); }}
                    data-tip={this.contextService.get('tooltipOnOff') === 'on' ? this.props.tooltip : ''}
                    data-for={this.tooltip_id}
                    style={btnStyle ? btnStyle : undefined}
                >
                    {this.props.insideText ?
                        <div
                            style={{
                                marginLeft: insideMargin,
                                ...(this.props.style === 'theme_small' ? { borderBottom: '1px solid' } : {})
                            }}
                        >
                            {this.props.insideText}
                        </div>
                        : null
                    }
                </button>
                {this.props.sidetext && <span style={{ fontSize: '10px', color: '#888' }}> {this.props.sidetext} </span>}
                <ReactTooltip
                    className={style.tooltip}
                    id={this.tooltip_id}
                    place={this.props.place === 'bottom' ? 'bottom' : 'top'}
                    type='info'
                    effect='solid' />
            </div>
        );
    }

}
